export default __webpack_public_path__ + "static/media/0xf7058856f405542cd660e8ce4751248f2d037f2b.07d6068a.png";